// extracted by mini-css-extract-plugin
module.exports = {"outer":"Ihggz","leftWrapper":"_2Uqse","heading":"_3kqUF","subHeading":"_2toZ0"};